var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "client-view p-10" },
    [
      _c(
        "div",
        {
          staticClass: "bg-FFDA3E p-10",
          staticStyle: { overflow: "hidden", "border-radius": "10px" },
        },
        [
          _c(
            "van-collapse",
            {
              model: {
                value: _vm.activeNames,
                callback: function ($$v) {
                  _vm.activeNames = $$v
                },
                expression: "activeNames",
              },
            },
            [
              _c(
                "van-collapse-item",
                {
                  attrs: { name: "1" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-60 h-60 bg-FF text-center m-l-30 l-h-65",
                                staticStyle: { "border-radius": "50%" },
                              },
                              [
                                _c("van-icon", {
                                  attrs: {
                                    color: "#FFDA3E",
                                    size: "16",
                                    name: "manager",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bg-FFDA3E font-32 font-weight-500 p-l-20 cor-3E3A39",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.formData.companyName) + " "
                                ),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "flex m-t-30" }, [
                            _c(
                              "div",
                              [_c("van-icon", { attrs: { name: "location" } })],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-28 cor-33 font-weight-400 m-l-10",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formData.companyPlace ||
                                        "暂未录入地址"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    [
                      _vm.formData.parentId
                        ? _c(
                            "van-row",
                            { attrs: { type: "flex", align: "center" } },
                            [
                              _c("van-col", { attrs: { span: "6" } }, [
                                _c(
                                  "div",
                                  { staticClass: "font-24 cor-3E3A39" },
                                  [_vm._v("上级单位：")]
                                ),
                              ]),
                              _c("van-col", { attrs: { span: "18" } }, [
                                _c(
                                  "div",
                                  { staticClass: "cor-33" },
                                  [
                                    _c("form-view-item", {
                                      staticClass: "font-24",
                                      attrs: {
                                        value: _vm.formData.parentId,
                                        isShowIcon: false,
                                        placeholder: "请选择上级单位",
                                        options: {
                                          data: _vm.parentId.data,
                                          showFields: "companyName",
                                          valueKey: "id",
                                          fontSize: "24",
                                        },
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.parentId.show = true
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("客户级别："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    value: _vm.formData.companyLevel,
                                    placeholder: "请选择客户级别",
                                    options: {
                                      data: _vm.companyLevel.data,
                                      showFields: "dictLabel",
                                      valueKey: "dictValue",
                                      fontSize: "24",
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.companyLevel.show = true
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("单位类型："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    value: _vm.formData.companyNature,
                                    options: {
                                      data: _vm.companyNature.data,
                                      showFields: "dictLabel",
                                      valueKey: "dictValue",
                                      fontSize: "24",
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.companyNature.show = true
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("客户规模："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    value: _vm.formData.customBase,
                                    options: {
                                      data: _vm.customBase.data,
                                      showFields: "dictLabel",
                                      valueKey: "dictValue",
                                      fontSize: "24",
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.customBase.show = true
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("行业："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    value: _vm.formData.companyIndustry,
                                    options: {
                                      data: _vm.companyIndustry.data,
                                      showFields: "dictLabel",
                                      valueKey: "dictValue",
                                      fontSize: "24",
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.companyIndustry.show = true
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("客户来源："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    value:
                                      _vm.formData.companySource.toString(),
                                    options: {
                                      data: _vm.companySource.data,
                                      showFields: "dictLabel",
                                      valueKey: "dictValue",
                                      fontSize: "24",
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.companySource.show = true
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("业务委托形式："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    value: _vm.formData.companyEntrustType,
                                    options: {
                                      data: _vm.companyEntrustType.data,
                                      showFields: "dictLabel",
                                      valueKey: "dictValue",
                                      fontSize: "24",
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.companyEntrustType.show = true
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("法人："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    text: _vm.formData.companyLegalPerson,
                                    options: { fontSize: "24" },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("联系电话："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    text: _vm.formData.companyTelephone,
                                    options: { fontSize: "24" },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("地区："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    text: _vm.formData.companyProvinceName,
                                    options: { fontSize: "24" },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        { attrs: { type: "flex", align: "center" } },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "font-24 cor-3E3A39" }, [
                              _vm._v("成交笔数："),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c(
                              "div",
                              { staticClass: "cor-33" },
                              [
                                _c("form-view-item", {
                                  attrs: {
                                    isShowIcon: false,
                                    text: _vm.formData.contractNum,
                                    options: { fontSize: "24" },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "van-tabs",
        {
          staticClass: "m-t-20",
          on: { click: _vm.tableClick },
          model: {
            value: _vm.tabIndex,
            callback: function ($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex",
          },
        },
        [
          _c("van-tab", { attrs: { name: "0", title: "联系人" } }),
          _c("van-tab", { attrs: { name: "1", title: "拜访记录" } }),
        ],
        1
      ),
      _vm.tabIndex == 0
        ? _c(
            "van-cell-group",
            { staticClass: "m-t-10" },
            [
              _c("van-notice-bar", {
                attrs: {
                  "left-icon": "volume-o",
                  text: "本人创建的联系人可右滑修改。",
                },
              }),
              _vm._l(_vm.customer.list, function (item, i) {
                return _c(
                  "div",
                  { key: i },
                  [
                    _c(
                      "van-swipe-cell",
                      {
                        attrs: {
                          disabled: item.createBy != _vm.userInfo.userId,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "right",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-34 p-l-50 p-r-50",
                                      staticStyle: {
                                        height: "100%",
                                        background: "#FFDA3E",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            position: "relative",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                          },
                                        },
                                        [_vm._v("修改")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("div", { staticClass: "p-20 flex" }, [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-80 h-80 bg-FFDA3E font-36 text-center l-h-80",
                                staticStyle: { "border-radius": "50%" },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(item.userName?.charAt(0)) + " "
                                ),
                              ]
                            ),
                          ]),
                          _c("div", [
                            _c("p", { staticClass: "font-30 cor-33 m-l-20" }, [
                              _c("span", [_vm._v(_vm._s(item.userName))]),
                              _c("span", { staticClass: "m-l-20" }, [
                                _vm._v(_vm._s(item.userTelephone)),
                              ]),
                            ]),
                            _c(
                              "p",
                              { staticClass: "font-30 cor-33 m-l-20 m-t-6" },
                              [_vm._v(_vm._s(item.userMobile))]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.tabIndex == 1
        ? _c(
            "div",
            { staticClass: "m-t-10" },
            _vm._l(_vm.customerVisit.list, function (item) {
              return _c(
                "van-cell-group",
                { key: item.id, staticClass: "m-t-10 p-20" },
                [
                  _c(
                    "van-row",
                    {
                      attrs: { align: "center" },
                      on: {
                        click: function ($event) {
                          return _vm.detail(item.id)
                        },
                      },
                    },
                    [
                      _c(
                        "van-row",
                        {
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c(
                            "van-col",
                            { attrs: { span: "3" } },
                            [
                              _c("van-icon", {
                                staticClass: "p-t-20",
                                attrs: {
                                  size: "30",
                                  name: "friends",
                                  color: "#FFDA3E",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("van-col", { attrs: { span: "19" } }, [
                            _c("div", { staticClass: "sender-info" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "cor-33 font-30 font-weight-600",
                                },
                                [_vm._v(_vm._s(item.customerCompanyName))]
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        {
                          staticClass: "m-t-1",
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("span", { staticClass: "cor-88 font-28" }, [
                              _vm._v("拜访人"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "cor-33 font-28" }, [
                              _vm._v(_vm._s(item.customerUserName)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        {
                          staticClass: "m-t-1",
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("span", { staticClass: "cor-88 font-28" }, [
                              _vm._v("拜访时间"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "cor-33 font-28" }, [
                              _vm._v(_vm._s(item.visitTime)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        {
                          staticClass: "m-t-1",
                          attrs: {
                            type: "flex",
                            align: "top",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("span", { staticClass: "cor-88 font-28" }, [
                              _vm._v("拜访记录"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "cor-33 font-28 hjj" }, [
                              _vm._v(_vm._s(item.visitGoal)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider"),
                      _c(
                        "van-row",
                        {
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "font-28 cor-00" }, [
                              _vm._v("记录："),
                            ]),
                            _c("span", { staticClass: "font-28 cor-00" }, [
                              _vm._v(
                                _vm._s(item.createByName) +
                                  " " +
                                  _vm._s(_vm.convertTime(item.createTime))
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }